import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/system/Container';
import Master from 'front/MasterAdmin';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { hasErrors } from '../../../common/enums';
import { Campagne, newCampagne as brandNewCampagne } from '../../../common/models/campagnes';
import { adminSlice } from '../../../common/store/admin';
import { campagneSlice } from '../../../common/store/campagnes';
import { AppState, appStore, campagneSelector } from '../../../common/store/store';
import { postData } from '../../api';

const CampagneItem = (props: { campagne: Campagne; }) => {

    const navigate = useNavigate();

    return <ListItemButton onClick={() => { navigate('/admin/campagne/' + props.campagne.id); }}>
        <ListItemText primary={props.campagne.name} />
    </ListItemButton>;
};

export const Campagnes = () => {

    const campagnes = useSelector((state: AppState) => campagneSelector.selectAll(state));

    const newCampagne = useSelector((state: AppState) => state.admin.newCampagne);
    const [err, setErr] = React.useState<ResponseError[] | undefined>();

    const onAjouterClick = async () => {
        const response = await postData<Campagne>('campagnes', newCampagne);
        if (hasErrors(response)) {
            setErr(response);
        } else {
            setErr(undefined);
            appStore.dispatch(campagneSlice.actions.addOne(response));
            appStore.dispatch(adminSlice.actions.updateNewCampagne(brandNewCampagne));

        }
    };

    return <Master><Container maxWidth={false}><Typography variant={'h1'}>Campagnes</Typography>
        <List>
            {campagnes.map(ae => <CampagneItem key={ae.id} campagne={ae} />)}
        </List>
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Box sx={{ flexGrow: 1 }}>
                <TextField
                    fullWidth
                    value={newCampagne.name}
                    onChange={(event) => {
                        appStore.dispatch(adminSlice.actions.updateNewCampagne({ name: event.target.value }));
                    }}
                    type='text'
                    required
                    size='small'
                    sx={{ width: '100%' }}
                    error={!!err?.find(p => p.param == 'name')}
                    helperText={err?.find(p => p.param == 'name')?.msg}
                    placeholder='Nom de la campagne' />
            </Box>
            <Box>
                <Button
                    disabled={newCampagne.name == ''}
                    size='small'
                    variant='contained'
                    onClick={onAjouterClick}>Ajouter</Button>
            </Box>
        </Box>
    </Container></Master>
        ;
};
